import { __generator } from "tslib";
import { takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../constants/actionTypes';
export default function triggerAssetDownload() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(actionTypes.ASSETS_ZIP_CREATED, function (_a) {
                    var url = _a.url;
                    // TODO this work in IE/Edge?
                    window.location.href = url;
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
